

































import Segment from '@/components/estimates/common/segments/Segment';
import {EstimateState, Photo} from '@/model/api';
import {Estimate} from '@/model/Estimate';
import {blobToDataURL} from 'blob-util';
import {right} from 'fp-ts/lib/Either';
import {Component, Inject, Prop} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import {PhotoWasUploaded, UploadStarted} from './controls/events';
import PhotoControl from './controls/PhotoControl.vue';
import PhotoUpload from './controls/PhotoUpload.vue';

@Component({
    components: {
        PhotoUpload,
        PhotoControl,
        draggable,
    },
})
export default class PhotosSegment<T extends EstimateState> extends Segment<T> {
    @Inject()
    public readonly model: Estimate<T>;

    @Prop({type: Array, required: true})
    public readonly photos: Photo[];

    @Prop({type: Object, required: true})
    public readonly estimate: T;

    public canChangePhotoPosition = this.model.changePhotoPosition !== undefined;

    private estimateState = this.estimate;

    private photosData: Photo[] = [...this.photos];
    private processingPhotos: {[photoId: string]: boolean} = {};

    private runningUploads: {[uploadId: string]: string} = {};

    public uploadStarted(event: UploadStarted): void {
        blobToDataURL(event.file)
            .then(dataUri => {
                this.runningUploads = {...this.runningUploads, [event.uploadId]: dataUri};
            });
    }

    public photoUploaded(event: PhotoWasUploaded): void {
        this.photosData.push(event);
        this.$delete(this.runningUploads, event.uploadId);

        if (Object.keys(this.runningUploads).length === 0) {
            this.refresh();
        }
    }

    public photoMoveStarted(photoId: string) {
        this.$set(this.processingPhotos, photoId, true);
    }

    public photoMoved() {
        this.refresh();
    }

    public photoRemoved(removedPhoto: Photo): void {
        this.photosData = this.photosData.filter(photo => photo.id !== removedPhoto.id);
    }

    public onDragEnd(event: { newIndex: number }): void {
        if (this.model.changePhotoPosition === undefined) {
            throw new Error('Estimate does not support photo position change');
        }

        const position = event.newIndex;
        const photoId = this.photosData[position]?.id; // Use optional chaining just in case

        this.model.changePhotoPosition(photoId, position)
            .then(() => this.refresh());
    }

    public async submit() {
        return right(this.estimateState);
    }

    public hasNotSubmittedChanges(): boolean {
        return false; // this segment does not use submit button
    }

    public clearNotSubmittedChanges(): void {
    }

    public allowsMovingOn(): boolean {
        return true;
    }

    private refresh(): void {
        this.model.getEstimate()
            .then(estimate => {
                this.estimateState = estimate;

                this.photosData = [...(estimate.photos!)];
                this.processingPhotos = Object.fromEntries(estimate.photos!.map(photo => [photo.id, false]));
            });
    }
}
